/**
 * @generated SignedSource<<3b1c0f9119b8bf51f33cc78c86df7508>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type KPIAdminQuery$variables = Record<PropertyKey, never>;
export type KPIAdminQuery$data = {
  readonly store: {
    readonly id: string;
    readonly routines: ReadonlyArray<{
      readonly id: string;
      readonly title: string;
      readonly " $fragmentSpreads": FragmentRefs<"KPIAdminListItem_Routine">;
    }> | null;
  };
};
export type KPIAdminQuery = {
  response: KPIAdminQuery$data;
  variables: KPIAdminQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": "KPI"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "icon",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "KPIAdminQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Routine",
            "kind": "LinkedField",
            "name": "routines",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "KPIAdminListItem_Routine"
              }
            ],
            "storageKey": "routines(type:\"KPI\")"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "KPIAdminQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Routine",
            "kind": "LinkedField",
            "name": "routines",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Schedule",
                "kind": "LinkedField",
                "name": "schedule",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RecurrenceRule",
                    "kind": "LinkedField",
                    "name": "rules",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "byweekday",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RoutineSection",
                "kind": "LinkedField",
                "name": "activeSections",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Team",
                    "kind": "LinkedField",
                    "name": "assignedTeam",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "color",
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "routines(type:\"KPI\")"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4cb052e7120e2b9a366c4da5986c80c8",
    "id": null,
    "metadata": {},
    "name": "KPIAdminQuery",
    "operationKind": "query",
    "text": "query KPIAdminQuery {\n  store {\n    id\n    routines(type: KPI) {\n      id\n      title\n      ...KPIAdminListItem_Routine\n    }\n  }\n}\n\nfragment KPIAdminListItem_Routine on Routine {\n  id\n  title\n  icon\n  schedule {\n    rules {\n      byweekday\n    }\n  }\n  activeSections {\n    id\n    assignedTeam {\n      id\n      ...KPITeamIcon_Team\n    }\n  }\n}\n\nfragment KPITeamIcon_Team on Team {\n  id\n  color\n  icon\n}\n"
  }
};
})();

(node as any).hash = "09dfdee0540df2b0fa4dc7734f13e482";

export default node;
